import {
  createStore
} from 'vuex'

import http from "@/services/AuthService";

export default createStore({
  state: {
    TokenAccessToken: '',
    AgentInfo: {
      PRENAME: '',
      NAME: '',
      SURNAME: '',
      EPRENAME: '',
      ENAME: '',
      ESURNAME: '',
      MOBILE_PHONE: '',
      EMAIL: '',
      ADDRESS: [],
      ACC_NO: '',
      ACC_BRANCH: ''
    },
    EditAgentInfo: {
      AGENTCODE: '',
      CHANGE_THI: {
        PRENAME: '',
        NAME: '',
        SURNAME: '',
        SUBJOB: "E01",
        SUCCESS: false
      },
      CHANGE_ENG: {
        EPRENAME: '',
        ENAME: '',
        ESURNAME: '',
        SUBJOB: 'E02',
        SUCCESS: false,
        FILE: {
          FILE: '',
          FILE_NAME: 'CHANGE_ENG_DOC',
          FILE_TYPE: ''
        }
      },
      CHANGE_MOBILE_PHONE: {
        MOBILE_PHONE: '',
        SUBJOB: "E03",
        SUCCESS: false
      },
      CHANGE_EMAIL: {
        EMAIL: '',
        SUBJOB: "E04",
        SUCCESS: false,
      },
      CHANGE_BANK: {
        ACC_NO: '',
        ACC_BANK: '',
        ACC_BRANCH: '',
        SUBJOB: "E06",
        SUCCESS: false,
        ACC_DOC: {
          FILE: '',
          FILE_NAME: 'ACC_BOOKBANK',
          FILE_TYPE: ''
        }
      },
      CHANGE_ADDRESS: {
        ADDRESS: [],
        SUBJOB: "E05",
        SUCCESS: false
      },
      CHANGE_VAT: {
        VAT_DOC: {
          FILE: '',
          FILE_NAME: 'VAT_DOC',
          FILE_TYPE: ''
        },
        SUBJOB: "E07",
        SUCCESS: false
      },
      CHANGE_OTHER: {
        SUBJOB: "E08",
        SUCCESS: false
      }
    },
    Otp: {
      ISEMAIL: false,
      REFERENCE: '',
      KEY: '',
    },
    SocialMediaInfo: {
      LineID: {
        IsEditLineID: false,
        Data: {
          OldLineID: '',
          NewLineID: ''
        }
      },
      Facebook: {
        IsEditFacebook: false,
        Data: {
          OldFacebookName: '',
          NewFacebookName: ''
        },
      },
      TikTok: {
        IsEditTikTok: false,
        Data: {
          OldTikTokName: '',
          NewTikTokName: ''
        },
      },
      Instagram: {
        IsEditInstagram: false,
        Data: {
          OldInstagramName: '',
          NewInstagramName: ''
        }
      },
      X: {
        IsEditX: false,
        Data: {
          OldXName: '',
          NewXName: ''
        }
      }
    },
    UserName: '',
    Email: '',
    Mobile_Phone: '',
    UserOffice: '',
    User_AG_STLV_SP: '',
    User_AG_STATUS: '',
    User_AG_LEVEL: '',
    User_AGENTTYPE: '',
    //ยังไม่ได้ตรวจสอบ
    FullNameTh: '',
    PreNameTh: '',
    //ใช้งาน
    DetailModal: [],
    base64: '',
    PassSuJob: '',
    AddressHome: '',
    AddressHomeTele: '',
    AddressRegis: '',
    AddressRegisTele: '',
    AddressCont: '',
    AddressContTele: '',
    BranchName: '',
    PassHistory: {
      AER_SERVICE_JOB_ID: '',
      REQUEST_NO: '',
      FSYSTEM: '',
      FSYSTEM_DT_TEXT: '',
      JOB_DESC: '',
      STATUS_DESC: '',
      SUB_STATUS_DESC: '',
      JOB: '',
      STATUS: '',
      SUBJOB: '',
      SUB_STATUS: '',
      STATUS_DT_TEXT: '',
      STATUS_ID_TEXT: '',
      REMARKS: '',
    },
    PASS_OFFICE: {
      DETAIL: [],
      OFFICE: '',
      MEMO: ''
    },
    CHANGE_OFFICE: {
      AGENTCODE: '',
      AGENTCODE_CHG: [],
      OFFICE: '',
      CHG_BY: '',
      REASON_DTL: '',
      SUBJOB: 'D01',
      FILE: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'CHANGE_OFFICE_DOC'
      },
    },
    PASS_TRANFER: {
      DETAIL: [],
      TransFullName: ''
    },
    AGENT_TRAN: {
      AGENTCODE: '',
      AGENTCODE_TRAN: [],
      AGENTCODE_NEW_UPLINE: '',
      SUBJOB: 'T01',
      FILE: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'AGENT_TRAN_DOC'
      }
    },
    POL_TRAN: {
      AGENTCODE: '',
      AGENTCODE_POL_TRAN: '',
      SUBJOB: 'W01',
      POL_TRAN_DOC: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'POL_TRAN_DOC'
      }
    },
    PassTranfer: '',
    CHANGE_POSITION: {
      AGENTCODE: '',
      CHG_TYPE: '',
      AGENTCODE_CHG: '',
      AG_POSITION_ID: '',
      AD_INFO_DETAIL: '',
      SUBJOB: 'M01',
      FILE: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'CHANGE_POSITION_DOC'
      }
    },
    PASS_CHANGE_POSITION: {
      NAME: '',
      TITLE: '',
      CHG_TYPE: '',
      CHG_POT: '',
      MEMO: ''
    },
    ASSIGN_POSITION: {
      AGENTCODE: '',
      AGENTCODE_PROMOTE: '',
      AG_POSITION_ID: '',
      EXP_DETAIL: '',
      AD_INFO_DETAIL: '',
      SUBJOB: 'P01',
      FILE: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'ASSIGN_POSITION_DOC'
      },
      FILE_EXP_DETAIL: {
        FILE: '',
        FILE_TYPE: '',
        FILE_NAME: 'EXP_DETAIL_DOC'
      },
    },
    PASS_ASSIGN_POSITION: {
      NAME: '',
      TITLE: '',
      CHG_POT: '',
      MEMO1: '',
      MEMO2: '',
    },
    REQUEST_CERT: {
      AGENTCODE: '',
      CERT_THI: {
        REASON_DTL: '',
        YEAR: '',
        SUBJOB: 'C01',
        SUCCEED: false
      },
      CERT_ENG: {
        REASON_DTL: '',
        YEAR: '',
        SUBJOB: 'C02',
        SUCCEED: false,
        FILE: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'CERT_EMPLOYMENT_ENG_DOC'
        },
        FILE_PASSPORT: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'PASSPORT_DOC'
        }
      },
      CERT_ENG_1YEAR: {
        REASON_DTL: '',
        YEAR: '',
        SUBJOB: 'C04',
        SUCCEED: false,
        FILE: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'CERT_EMPLOYMENT_ENG_1_YEAR_DOC'
        },
        FILE_PASSPORT: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'PASSPORT_DOC'
        }
      },
      CERT_ENG_2YEAR: {
        REASON_DTL: '',
        YEAR: '',
        SUBJOB: 'C03',
        SUCCEED: false,
        FILE: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'CERT_EMPLOYMENT_ENG_2_YEAR_DOC'
        },
        FILE_PASSPORT: {
          FILE: '',
          FILE_TYPE: '',
          FILE_NAME: 'PASSPORT_DOC'
        }
      },
    },
    CheckCertYear: '',
    RESIGN_MEMO: {
      AGENTCODE: '',
      REASON_DTL: '',
      SUBJOB: 'R01',
      FILE: {
        FILE: '',
        FILE_NAME: 'RESIGN_DOC',
        FILE_TYPE: ''
      }
    },
    CARD_PRINT: {
      AGENTCODE: '',
      CRAD: [],
      AD_INFO_DETAIL: '',
      PAYMENT_REF: '',
      SUBJOB: 'N01',
      FILE: {
        FILE: '',
        FILE_NAME: 'CARD_PRINT_DOC',
        FILE_TYPE: ''
      },
      FILE_PAYMENT: {
        FILE: '',
        FILE_NAME: 'CARD_PRINT_PAYMENT_DOC',
        FILE_TYPE: ''
      },
    },
    AccessToken: '',
    AgentCode: '',
    TypeAddressE: '',
    BoolMobilePhone: false,
    USER_NAME: '',
    ProspectAgentInfo: {
      MenuProspect: [],
      CurrentMenuProspect: 0// ใช้กับ ส่งเอกสารเพิ่มเติม
    },
    AgentRenewLicense: {
      CanRequestLicenseRenewal: null,// เช็คสถานะเริ่มต้น
      preview: {// หน้า-ขอต่ออายุใบอนุญาตออนไลน์ฯ / หน้าจอตรวจสอบข้อมูล
        dataResp: {
          isRegisUnitLink: false,// ตรวจสอบว่ามีสิทธิ์ผู้ขึ้นทะเบียนขาย Unit-Linked ถ้าไม่มี = false
          requestAgentRenewLicenseNo: 1,// ต่ออะไร
          form: {
            fullName: '',
            idCard: '',
            address: '',
            contactAddress: '',
            phone: '',
            email: '',
            advisor: '',
            registerId: '',
            approvalDate: '',
            expireDate: ''
          },
        },
        isRenewAgentRegis: false// ต้องการต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน (Unit Linked) ด้วยหรือไม่?
      },
      ConsentBySiteCode: null,
      tc7Cert: {// หน้า-อ่านคำรับรองคุณสมบัติ ตช.7 และรับรองคุณสมบัติ
        agree1: false,// ตช.7
        agree1_Date: null,
        agree2: false,// รับรองคุณสมบัติ
        agree2_Date: null,
      },
      uploadfile: {// หน้า-อัพโหลดเอกสาร
        files: {
          photo: null,// รูปถ่ายหน้าตรงใช้ติดบัตร
          certs: []// หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)
        },
        qualification: null,      // "has" หรือ "none"
        opt: false,// opt (เก็บสถานะ)
        course: '',// หลักสูตร (เก็บเฉพาะเมื่อ opt ถูกติ๊ก และมีการแสดงส่วนนี้)
      },
      verifyOTP: {// หน้า-SMS-OTP
        phoneNumber: '',// หมายเลขโทรศัพท์
        reference: '',// รหัสอ้างอิง
        expireDate: null,
        otp: '',// รหัส OTP
      },
      DataTrainingCourseRenewal: null,
    },
    data_agent_requests: [],
    BuildingAccessCard: {
      REQ_TYPE: '',// ความประสงค์ขอทำบัตร NEW : ทำบัตรครั้งแรก (New Card) REN : ต่ออายุบัตร (Renew) REP : ทำแทนบัตรเดิมที่สูญหาย/ชำรุด (Replacement)
      PICKUP_TYPE: '',// วิธีการรับบัตร BRN-สาขา/AO ที่สังกัด SEL-รับด้วยตนเองที่สำนักงานใหญ่ (เคาน์เตอร์สัญญาตัวแทน ชั้น 10)
      PAYMENT_FLG: '',// ต้องชำระเงินค่าบัตรหรือไม่ ระดับผู้จัดการภาคขึ้นไป, ผู้บริหารขั้นพิเศษ (พ.)  ไม่ต้องเสียค่าใช้จ่าย (กรณีทำบัตรหาย/ชำรุด จะต้องชำระค่าทำบัตรใหม่เอง) N=ไม่ต้องชำระ Y=ต้องชำระ\
      uploadfile: {
        files: {
          attachBAC: [],
        }
      }
    },
  },
  getters: {},
  mutations: {
    Authentication(state, AccessToken) {
      http.get("AgencyERequest/AuthenticationToken?", {
        headers: {
          Token: AccessToken,
          Authorization: `Bearer ${state.AccessToken}`
        }
      }).then((res) => {
        if (res.status != 200) {
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
          //window.open("https://smartpro.bangkoklife.com/AgencyERequestConvertor", '_self');
        } else {
          state.AgentCode = res.data.AGENTCODE;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    ValidateMobliePhone(state, val) {
      if (val !== '' && (val === '06' || val === '08' || val === '09')) {
        state.BoolMobilePhone = true;
      } else {
        state.BoolMobilePhone = false;
      }
    },
    Submit(state, SUBJOB) {
      if (SUBJOB === 'R01') {
        this.commit('Resignation');
      }
    },
  },
  actions: {},
  modules: {}
})